const isDev = process.env.NODE_ENV === "development";
/**
 *  online：线网环境
 *  mock：mock环境
 *  dev: 开发环境
 */
export default {
    //登录
    loginApi :isDev ? '/login/commonApi' : '',
    // 系统设置 api
    commonApi: isDev ? '/online/commonApi/scyq/manage' : '/scyq/manage',
    // 业务逻辑 api
    businessApi: isDev ? '/online/commonApi/scyq/manage' : '/scyq/manage',
    // 企业管理 api
    companyApi: isDev ? '/online/commonApi/scyq' : '/scyq',
    // 积分制平台 api
    integralApi: isDev ? '/online/commonApi/scyq/portal' : '/scyq/portal',
    //创新创业子平台
    innovationApi: isDev ? '/online/commonApi/scyq' : '/scyq',
    //科技金融子平台
    financeApi: isDev ? '/online/commonApi/scyq/web' : '/scyq/web',
    // 文件上传 api
    uploadApi: isDev ? '/uploadApi/scyq' : '/scyq',
}
